"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Separator = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
exports.Separator = function (_a) {
    var className = _a.className, restProps = tslib_1.__rest(_a, ["className"]);
    return (react_1.default.createElement("hr", tslib_1.__assign({ className: classnames_1.default("gd-separator-generic", className) }, restProps)));
};
//# sourceMappingURL=Separator.js.map